import { Component, Prop } from 'vue-property-decorator';
import { BaseComponent } from '@/components/base-component';
import { CGReservationStatus } from '../../enums/CGReservationStatus';
import { ApartmentFeature } from '../../enums/ApartmentFeature';
import { ApartmentPriceTableColumn } from '../../enums/ApartmentPriceTableColumn';
import { ApartmentSearchDTO } from '../../model/ApartmentSearchDTO';
import { FloorAbbrForTooltip } from '../../enums/FloorAbbrForTooltip';
import { ApartmentSearchSortType } from '../../enums/ApartmentSearchSortType';

@Component
export class ApartmentPriceTableRow extends BaseComponent {
	@Prop() apartment: ApartmentSearchDTO;
	@Prop() showPackagePrice: boolean;
	@Prop() showPackageInfo: boolean;
	@Prop() showFinalDiscount: boolean;
	@Prop() last: number;
	@Prop() sortType: ApartmentSearchSortType;

	@Prop() hideColumns: ApartmentPriceTableColumn[];

	get completed() {
		return new Date(this.apartment.completionDate) < this.getCurrentDate();
	}

	get isShowApartment() {
		return this.apartment.cgReservationStatus === CGReservationStatus.ShowApartment;
	}

	get isSpecialLocationInvest() {
		return (this.apartment.locationCatalogNumber == '152' && this.apartment.housingBlockName == 'A')
	}

	get isSpecialLocationName() {
		return (this.apartment.locationCatalogNumber == '189' && this.apartment.housingBlockName == 'A')
	}


	get hasPremiumPriceOnRequest() {
		return this.apartment.features.includes(ApartmentFeature.PremiumPriceOnRequest);
	}

	getIconForLang(iconName: string, extension: string) {
		return require(`@/assets/img/${iconName}-${this.$store.getLocale().split('-')[0].toUpperCase()}.${extension}`);
	}

	navigateToApartment() {
		if (this.isShowApartment || this.apartment.sold) {
			return;
		}

		console.log(this.apartment);

		let url = this.apartment.isPremium
			? `//www.central-group.cz/byt-detail-premium.aspx?idByt=${this.apartment.catalogNumber}`
			: `/byt-detail/${this.apartment.catalogNumber}`;

		if (this.$route.query.predbezne && this.$route.query.csh) {
			const joiningChar = url.includes('?') ? '&' : '?';
			url = `${url}${joiningChar}csh=${this.$route.query.csh}&predbezne=${this.$route.query.predbezne}`;
		}

		window.open(url);
	}

	showColumn(column: ApartmentPriceTableColumn) {
		return !this.hideColumns || !this.hideColumns.includes(column);
	}

	showTooltipFloor(floorAbbr: string) {
		//let floorAbbrList = ['NP0', 'NP00'];
		return (<any>Object).values(FloorAbbrForTooltip).includes(floorAbbr);
	}

	reactive: boolean = true;	// to make isFavorite reactive at least to a change to this variable

	isFavorite(apartment: ApartmentSearchDTO, reactive: boolean) {
		return this.$cookiesService.getFavoriteProducts().includes(apartment.catalogNumber);
	}

	toggleFavorite(catalogNumber: string, to: boolean) {
		this.$cookiesService.setFavoriteProducts(to ? this.$cookiesService.getFavoriteProducts().concat(catalogNumber) : this.$cookiesService.getFavoriteProducts().filter(p => p != catalogNumber));
		this.reactive = !this.reactive;
	}

	get searchSort() {
		return parseInt(this.$route.query.sort) as ApartmentSearchSortType;
	}
}

export default ApartmentPriceTableRow;
